export default "__VITE_ASSET__B2H4_oXY__"